import $ from 'jquery';

const duration = 200;

const initToggler = (parentsClass) => {
  const parents = [...document.getElementsByClassName(parentsClass)];
  for (let index = 0; index < parents.length; index++) {
    const parent = parents[index];

    const toggle = parent.querySelector('[data-toggle]');
    const less = toggle ? toggle.dataset.labelLess : '';
    const more =  toggle ? toggle.dataset.labelMore : '';
    const showForSr = toggle ? toggle.querySelector('.show-for-sr') : null;

    const toggler = parent.querySelector('[data-toggler]');
    if (!toggler) continue;

    $(toggler).on('on.zf.toggler', () => {
      $(toggler).slideDown(duration);
      parent.classList.add(`${parentsClass}-open`);
      if (less && toggle) {
        if (showForSr) {
          showForSr.textContent = less;
        } else {
          toggle.textContent = less;
        }
      }
    })
    $(toggler).on('off.zf.toggler', () => {
      $(toggler).slideUp(duration);
      parent.classList.remove(`${parentsClass}-open`);
      if (more && toggle) {
        if (showForSr) {
          showForSr.textContent = more;
        } else {
          toggle.textContent = more;
        }
      }
      if (toggle) toggle.focus();
    })

    // Force toggle to init with the correct position
    if (toggler.style.display !== 'none') {
      $(toggler).foundation('toggle');
    }
  }
}

window.addEventListener('load', () => {
  initToggler('card--doc');
});
